module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS4yNDkiIGhlaWdodD0iMzQuNDk5Ij48cGF0aCBkYXRhLW5hbWU9Iu2MqOyKpCA0OCIgZD0iTTIxMy44NzgsMTAzLjE3OGExLjk5NCwxLjk5NCwwLDAsMS0xLjQxNC0uNTg2TDE5Ny4yMTQsODcuMzQzYTIsMiwwLDAsMSwwLTIuODI4bDE1LjI0OS0xNS4yNDlhMiwyLDAsMCwxLDIuODI4LDIuODI4TDIwMS40NTcsODUuOTI4bDEzLjgzNSwxMy44MzVhMiwyLDAsMCwxLTEuNDE0LDMuNDE0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE5Ni42MjggLTY4LjY3OSkiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/ico/ico_angle.svg
// module id = aA6L
// module chunks = 0